import { IAsyncThunkAction } from 'common/core/interfaces/actions'
import { setFlowHasDraft } from 'common/flow/actions/flowActions'
import * as API from 'constants/API'
import { Body } from 'utils/api/types'
import { getClientId } from 'utils/clientId'

export const patchFlowDraft = (
  flowId: string,
  patch: SafeUnknownObject,
  coordinates: Record<string, { x: number; y: number }>,
): IAsyncThunkAction => {
  return async (dispatch, getState, { api }) => {
    const response = await api.post<{ has_unpublished_changes?: boolean } & Body>(
      API.flow.endpoints.patchFlowDraft,
      {
        body: { ns: flowId, batch: patch, coordinates, client_id: getClientId() },
      },
    )

    // todo remove `?? true` after backend's rollout
    dispatch(setFlowHasDraft(flowId, response.has_unpublished_changes ?? true))
  }
}
